import script from "./CenterPart.vue?vue&type=script&setup=true&lang=js"
export * from "./CenterPart.vue?vue&type=script&setup=true&lang=js"

import "./CenterPart.vue?vue&type=style&index=0&id=285ded83&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-285ded83"]])

export default __exports__